module.exports = __webpack_public_path__ + "img/professioneel-logo-personal-trainer-coaching-power-up-drongen-4.7d25cb6c.jpg";